import { render } from "./PatientMeasurementsSheet.vue?vue&type=template&id=4868b964"
import script from "./PatientMeasurementsSheet.vue?vue&type=script&lang=ts"
export * from "./PatientMeasurementsSheet.vue?vue&type=script&lang=ts"

import "./PatientMeasurementsSheet.vue?vue&type=style&index=0&id=4868b964&lang=stylus"
script.render = render

export default script